module.exports = __webpack_public_path__ + "media/images/background-9-2815d48d2cb4f636011e65d513d858b8.svg";